// =============================================================================
// Login / Register / Reset popup — Fancybox v5 inline modal.
//
// External triggers:
//     <a data-login-popup>             → opens, defaults to Login form
//     <a data-login-popup="register">  → opens on Register form
//     <a data-login-popup="reset">     → opens on Reset Password form
//
// Inside the popup .js-showLogin / .js-showRegister / .js-showReset switch
// between forms. forms.js closes the Fancybox on successful submission.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $popup = $('#login-popup');
        if (!$popup.length) { return; }

        const FORM_SELECTORS = '.js-loginForm, .js-registerForm, .js-resetForm';

        function selectorFor(name) {
            switch (name) {
                case 'register': return '.js-registerForm';
                case 'reset':    return '.js-resetForm';
                default:         return '.js-loginForm';
            }
        }

        function showForm(name) {
            $popup.find(FORM_SELECTORS).attr('hidden', 'hidden');
            const $target = $popup.find(selectorFor(name)).removeAttr('hidden');

            // Defer focus so Fancybox's own focus-trap doesn't fight us.
            setTimeout(() => {
                $target.find('input:not([type=hidden]):visible, select:visible').first().trigger('focus');
            }, 50);
        }

        $popup.on('click', '.js-showLogin',    (e) => { e.preventDefault(); showForm('login'); });
        $popup.on('click', '.js-showRegister', (e) => { e.preventDefault(); showForm('register'); });
        $popup.on('click', '.js-showReset',    (e) => { e.preventDefault(); showForm('reset'); });

        $(document).on('click', '[data-login-popup]', function (e) {
            e.preventDefault();
            if (typeof Fancybox === 'undefined') { return; }

            const startForm = $(this).attr('data-login-popup') || 'login';
            showForm(startForm);

            Fancybox.show(
                [{ src: '#login-popup', type: 'inline' }],
                {
                    mainClass: 'fancybox--login-popup',
                    dragToClose: false,
                    Carousel: { Panzoom: false },
                }
            );
        });
    });
})(jQuery);
